function cleanMessage(error) {
  return String(error?.message || '')
    .replace(/^FirebaseError:\s*/i, '')
    .replace(/^\[[^\]]+\]\s*/i, '')
    .trim();
}

function cleanCode(error) {
  return String(error?.code || '').toLowerCase();
}

const ACTIONABLE_SAVE_MESSAGES = [
  /choose a valid event date and time/i,
  /choose whether members pay/i,
  /whole-series paid events need an end date/i,
  /static checkout links cannot be used/i,
  /sales must open before they close/i,
  /payment basis and recurrence schedule are locked/i,
  /external attendee settings are locked/i,
  /waitlist claim time must be/i,
  /set a capacity before enabling/i,
  /capacity cannot be lower than/i,
  /add a city and country/i,
];

export function isActionableEventSaveFailure(error) {
  const detail = cleanMessage(error);
  return ACTIONABLE_SAVE_MESSAGES.some(pattern => pattern.test(detail));
}

export function eventSaveFailureMessage(error) {
  const code = cleanCode(error);
  const detail = cleanMessage(error);
  if (isActionableEventSaveFailure(error)) return detail;
  if (code.includes('permission-denied')) {
    return 'You do not have permission to save this event. Ask a club admin to give you Events and calendar permission.';
  }
  if (code.includes('unavailable') || code.includes('deadline-exceeded')) {
    return 'The event service could not be reached. Check your connection and try Save again.';
  }
  if (code.includes('invalid-argument') && detail) return detail;
  return 'Could not save the event. No event was created. Check the highlighted details and try again.';
}

export function eventPostSaveWarning(phase, error) {
  const code = cleanCode(error);
  const detail = cleanMessage(error);
  const step = phase || 'the remaining setup';
  if (code.includes('not-found')) {
    return `Event saved, but ${step} could not finish because the latest event service is not available yet. Reopen the event and save it again after the platform functions have been updated.`;
  }
  if (code.includes('permission-denied')) {
    return `Event saved, but ${step} could not finish because your account lacks permission for that step. Ask a club admin to check your Events and calendar permission, then reopen and save the event again.`;
  }
  if (code.includes('unavailable') || code.includes('deadline-exceeded')) {
    return `Event saved, but ${step} could not finish because the service could not be reached. Check your connection, then reopen the event and save it again.`;
  }
  return `Event saved, but ${step} could not finish. Reopen the event and save it again.${detail ? ` Details: ${detail}` : ''}`;
}
